import { Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-video-player',
  imports: [CommonModule],
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.css']
})
export class VideoPlayerComponent {

  @ViewChild('videoElement', { static: true })
  videoRef!: ElementRef<HTMLVideoElement>;

  src = '';
  startTime = 0;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.src = this.route.snapshot.queryParamMap.get('src') ?? '';
    this.startTime = Number(this.route.snapshot.queryParamMap.get('t') ?? 0);

    const video = this.videoRef.nativeElement;

    video.addEventListener('loadedmetadata', () => {
      if (this.startTime > 0) {
        video.currentTime = this.startTime;
      }
    });
  }
}